import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "catalog catalog--layout-single-item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CircularSpinner = _resolveComponent("CircularSpinner");
    const _component_CatalogItem = _resolveComponent("CatalogItem");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loadingProducts)
            ? (_openBlock(), _createBlock(_component_CircularSpinner, {
                key: 0,
                size: 25
            }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["catalog__items products", `columns-${_ctx.config.columns}`])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (p, i) => {
                    return (_openBlock(), _createBlock(_component_CatalogItem, {
                        key: `product-${p.id}`,
                        host: _ctx.config.baseUrl,
                        product: p,
                        "show-add-to-cart-btn": _ctx.config.showAddToCartBtn,
                        "show-quantity-input": _ctx.config.showQuantityInput,
                        lang: _ctx.config.language,
                        onAddToCart: ($event) => (_ctx.addToCart($event, i)),
                        onViewDetails: ($event) => (_ctx.viewDetails($event, i))
                    }, null, 8 /* PROPS */, ["host", "product", "show-add-to-cart-btn", "show-quantity-input", "lang", "onAddToCart", "onViewDetails"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
    ]));
}
